/** @jsxImportSource theme-ui */

const Windy = () => (
  <iframe
    sx={{ flex: "auto" }}
    src="https://embed.windy.com/?700h,49.667,11.236,7"
    sandbox="allow-scripts"
  ></iframe>
)

export { Windy }
